import { Component, OnInit, OnDestroy,Pipe,PipeTransform} from '@angular/core';
import {Http, Headers, RequestOptions,Response} from '@angular/http';
import {ShareService } from './../services/services';
import {Video,VideoService } from './video.service';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { Title,BrowserModule,DomSanitizer,SafeHtml } from '@angular/platform-browser';
import {SlimLoadingBarService} from 'ng2-slim-loading-bar';
import { CopyWriteService} from './../services/copywrite.service';
import { MetaService } from 'ng2-meta';
import { EmbedVideoService } from 'ngx-embed-video';

declare var jQuery: any;


@Pipe({ name: 'safeHtml'})
export class SafeHtmlPipe implements PipeTransform  {
  constructor(private sanitized: DomSanitizer) {}
  transform(value) {
    console.log(this.sanitized.bypassSecurityTrustHtml(value))
    return this.sanitized.bypassSecurityTrustHtml(value);
  }
}

interface PageData {
  title: string;
  description: string;
  meta_title: string;
  meta_description: string;  
  
}

let bigtos_pluugging = document.querySelector('bigtos');
let plugging = bigtos_pluugging ? bigtos_pluugging.innerHTML : "";

let componentmodel;

if(plugging.length)
{
    
   
    let jsonObject : any = JSON.parse(plugging)
    //console.log("hotel:->"+JSON.stringify(jsonObject));
    
    if(jsonObject.video)
    {
	    componentmodel=true;
    }
    else
    {
	    componentmodel=false;
    }
}


let componentdata;
if(componentmodel)
{
   componentdata={templateUrl: './pg/video/video.component.html'}
}
else
{
   componentdata={template: '<div></div>'}   
}
@Component(componentdata)
/*
@Component({
	//template: require('./gallery.component.html')
	templateUrl: './pg/video/video.component.html'


	
})
*/
export class VideoComponent implements OnInit {
	
	
	pagedata: PageData;
	public serviceData;
	private _sub: Subscription;
	public metatitle;
    public metadescription;
    
    public category; 
    public gallery:Array<any>;
	constructor(
	    private http: Http,
	    private _route: ActivatedRoute,
	    private _router: Router,
	    private shareService: ShareService,
	    private _title: Title,
	    private _sanitizer: DomSanitizer,
	    private metaService: MetaService,
	    private slimLoadingBarService: SlimLoadingBarService,
	    private copywriteservice:CopyWriteService,
	    private embedService: EmbedVideoService,
	    private _pageService: VideoService) {
		   
		   this.pagedata = {
                  title:'',                  
                  description: '',
                  meta_title: '',
                  meta_description: ''
                 
				  	}		  
	    }
	    
  
	ngOnInit() {
	    // this.pagedata.description="umesh naga";
	    //  this.pagedata.slug="umesh naga";
	  this.slimLoadingBarService.start();  
	  this._sub = this._route.params.subscribe(params => {
			
						 //  console.log(slug);
			   //this._applicationService.doLogin().subscribe	      
			   //this._pageService.getPage(slug);
			   	let slug =params['slug'];			   	
			     this.category=slug;		   
			   
			   
			   this._pageService.getGallerylist(slug,null).subscribe(
        data => {
                 //                 
                  this.pagedata.title=data.menu.link_showing_name;
                  this.pagedata.description=data.menu.description;                 
                  if(data.menu.meta_title)
                  {
	                   this._title.setTitle(data.menu.meta_title);
	                   this.metaService.setTag('og:title',data.menu.meta_title);
                  }
                  else
                  this._title.setTitle(data.menu.link_showing_name);
                  
                  
                 if(data.menu.meta_description)                  
                  this.metaService.setTag('description',data.menu.meta_description);
                  
				   this.metaService.setTag('keywords',data.menu.meta_keywords);
                                   
                  this.gallery=data.gallery;
                  let self = this;
                   this.gallery.forEach(function (entry, i) {
	                   
	                    //console.log("inside loop");   
	                    	                         
	                   entry.gallery_description=self.sanitizeAndEmbedURLs(entry.gallery_description);
                   })
                   
                  this.slimLoadingBarService.complete();
                   let mainjs=this.shareService.getmainjs();
				   jQuery.getScript('./'+mainjs);

                   setTimeout(()=>{    //<<<---    using ()=> syntax
         
                
			      let copywrite=this.shareService.getcopywrite();  
			      //console.log("Mydata->"+this.siteinfo.site_address);
			              
			      this.copywriteservice.copywritelogo(copywrite);
				  },1000);
                  //$window.document.title ='someTitleYouCreated' ;
                  //console.log(this.pagedata.title);                               
              
           
        },
        err => console.error(err),
        () => console.log('services completed')
    );
			   
			   
			  
			   
			   		   
		});		
	
		
	}
	private sanitizeAndEmbedURLs(links) {
	
	//links.forEach((link, i) => {
	let videoid = links.match(/(?:https?:\/{2})?(?:w{3}\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\?v=|\/)([^\s&]+)/);
	if (videoid !== null) {
	links = "http://www.youtube.com/embed/" + videoid[1];
	}
	
	links = this._sanitizer.bypassSecurityTrustResourceUrl(links);
	//})
	return links;
	}
    public transform(value: string): SafeHtml {
		//return this._sanitizer.sanitizeAndEmbedURLs(value);
			return true;
	}  
 ngOnDestroy() {
       this._sub.unsubscribe();
    }

}


// WEBPACK FOOTER //
// ./resources/assets/typescript/video/video.component.ts